import { render, staticRenderFns } from "./order_details.vue?vue&type=template&id=03cf107a&scoped=true&"
import script from "./order_details.vue?vue&type=script&lang=js&"
export * from "./order_details.vue?vue&type=script&lang=js&"
import style0 from "./order_details.vue?vue&type=style&index=0&id=03cf107a&prod&lang=less&scoped=true&"
import style1 from "./order_details.vue?vue&type=style&index=1&id=03cf107a&prod&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03cf107a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SvgIcon: require('/app/components/svgIcon/svgIcon.vue').default,Ware: require('/app/components/ware-view/ware.vue').default,Checkout: require('/app/components/checkout/index.vue').default,Tooltip: require('/app/components/tooltip.vue').default})
